import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'normalize.css/normalize.css' // eslint-disable-line import/extensions, import/no-unresolved
import React from 'react'
import { Provider } from 'react-redux'
import store from 'redux/store'
import ReactDOM from 'react-dom'
import 'services'
import App from 'pages/App'

if (process.env.NODE_ENV !== 'production') {
  import('@axe-core/react').then(({ default: axe }) => {
    axe(React, ReactDOM, 1000)
  })
}

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)
